type IdentifierType = 'email' | 'phone';
type OtpChannel = 'sms' | 'email';

class AnalyticsService {
  private measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;

  private track(eventName: string, params?: Record<string, unknown>): void {
    if (!this.measurementId || !(window as any).gtag) {
      return;
    }

    try {
      gtag('event', eventName, params);
    } catch (error) {
      console.debug(`Analytics event failed: ${eventName}`, error);
    }
  }

  updateConsent(granted: boolean): void {
    if (!this.measurementId || !(window as any).gtag) {
      return;
    }

    try {
      gtag('consent', 'update', {
        'analytics_storage': granted ? 'granted' : 'denied'
      });
      console.debug(`GA4 Consent updated to: ${granted ? 'granted' : 'denied'}`);
    } catch (error) {
      console.debug('Failed to update GA4 consent', error);
    }
  }
  
  trackIdentifySubmitted(identifierType: IdentifierType): void {
    this.track('identify_submitted', { identifier_type: identifierType });
  }

  trackLoginPathDetermined(path: 'login' | 'registration'): void {
    this.track('login_path_determined', { path });
  }

  trackPasswordSubmitted(flowType: string): void {
    this.track('password_submitted', { flow_type: flowType });
  }

  trackLoginSuccess(flowType: string): void {
    this.track('login_success', { flow_type: flowType });
  }

  trackLoginFailure(flowType: string, errorCode?: string): void {
    this.track('login_failure', { flow_type: flowType, error_code: errorCode });
  }

  trackPasswordRecoverInitiated(flowType: string): void {
    this.track('password_recover_initiated', { flow_type: flowType });
  }

  trackOtpSubmitted(flowType: string, channel: OtpChannel): void {
    this.track('otp_submitted', { flow_type: flowType, channel });
  }

  trackOtpSuccess(flowType: string): void {
    this.track('otp_success', { flow_type: flowType });
  }

  trackOtpFailure(flowType: string, errorCode?: string): void {
    this.track('otp_failure', { flow_type: flowType, error_code: errorCode });
  }

  trackSetPasswordSubmitted(flowType: string): void {
    this.track('set_password_submitted', { flow_type: flowType });
  }

  trackSetPasswordSuccess(flowType: string): void {
    this.track('set_password_success', { flow_type: flowType });
  }

  trackSetPasswordFailure(flowType: string, errorCode?: string): void {
    this.track('set_password_failure', { flow_type: flowType, error_code: errorCode });
  }
}

export const analyticsService = new AnalyticsService();

declare function gtag(...args: any[]): void;